import "./SilentOperator.module.css";
import NavigationHeader from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ManagedSecuritySolutions from "./sections/ManagedSecuritySolutions";
import OurProprietaryProcess from "./sections/OurProprietaryProcess";
import DailyWorkflowPreview from "./sections/DailyWorkflowPreview";
import AppShowcase from "./sections/AppShowcase";
import Footer from "@/reusable_sections/Footer";
export default function SilentOperatorPage() {
  return <div>
      <NavigationHeader />
      <Hero />
      <ManagedSecuritySolutions />
      <OurProprietaryProcess />
      <DailyWorkflowPreview />
      <AppShowcase />
      <Footer />
    </div>;
}